import { useState } from "react"
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { Textarea } from "@/components/ui/textarea"
import { Label } from "@/components/ui/label"

interface RefusalModalProps {
	isOpen: boolean
	onClose: () => void
	onConfirm: (reason: string) => void
	isConfirming: boolean
}

export function RefusalModal({
	isOpen,
	onClose,
	onConfirm,
	isConfirming,
}: RefusalModalProps) {
	const [reason, setReason] = useState("")

	const handleConfirm = () => {
		if (reason.trim()) {
			onConfirm(reason)
		}
	}

	return (
		<AlertDialog
			open={isOpen}
			onOpenChange={onClose}
		>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>Recusar Inscrição</AlertDialogTitle>
					<AlertDialogDescription>
						Por favor, informe o motivo da recusa. Essa informação será
						registrada no sistema e enviada ao(s) colaborador(es) selecionado(s).
					</AlertDialogDescription>
				</AlertDialogHeader>
				<div className="py-4">
					<Label htmlFor="reason">Motivo da Recusa</Label>
					<Textarea
						id="reason"
						value={reason}
						onChange={(e) => setReason(e.target.value)}
						placeholder="Digite o motivo aqui..."
						className="mt-2"
					/>
				</div>
				<AlertDialogFooter>
					<AlertDialogCancel
						onClick={onClose}
						disabled={isConfirming}
					>
						Cancelar
					</AlertDialogCancel>
					<AlertDialogAction
						onClick={handleConfirm}
						disabled={!reason.trim() || isConfirming}
					>
						{isConfirming ? "Recusando..." : "Recusar"}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
